import React from 'react';
import { scrollToPricing } from '../utils/scroll';
type CtaButtonProps = {
  label?: string;
  className?: string;
  size?: 'md' | 'lg';
  /** When provided, the CTA links out to this URL instead of scrolling to pricing. */
  href?: string;
};
export function CtaButton({
  label = '🚀 I WANT CRICKET READY NOW',
  className = '',
  size = 'lg',
  href
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-base sm:text-lg' : 'px-6 py-3.5 text-sm sm:text-base';
  const baseClass = `inline-flex w-full items-center justify-center rounded-xl bg-grass font-display font-extrabold uppercase tracking-wide text-white shadow-lg shadow-grass/20 transition-[transform,background-color,box-shadow] duration-150 ease-out hover:-translate-y-0.5 hover:bg-grass-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grass active:translate-y-0 ${sizing} ${className}`;
  if (href) {
    return <a href={href} className={baseClass} data-id="element-81" data-mp="157n5t4keprp1">
        {label}
      </a>;
  }
  return <button type="button" onClick={scrollToPricing} className={baseClass} data-id="element-82" data-mp="35z8xktyca3lz">
      {label}
    </button>;
}